import { Dialog, IconButton } from '@mui/material'
import styles from './DateDialog.module.css'
import CloseIcon from '@mui/icons-material/Close'
import { ApplyButton } from './ApplyButton'
import { Calendar } from 'components/Calendar'
import { CancelButton } from '../CancelButton'

interface DateDialogProps{
    open: boolean
    onClose?: (event: any) => void
    onCancel?: (event: any) => void
    onOk?: (event: any) => void
    loading?: boolean
    customDay?: any
}

export const DateDialog = (props: DateDialogProps) => {
    const {
        open,
        loading,
        onCancel,
        onClose,
        onOk,
        customDay = undefined
    } = props

    
    const handleDialogClose = (event: any) => {
        onClose?.(event)
    }

    const handleSubmitForm = (event: any) => {
        event.preventDefault()
    }

    const handleCancelButtonClick = (event: any) => {
        onCancel?.(event)
    }

    const handleApplyButtonClick = (event: any) => {
        onOk?.(event)
    }

    return (
            <Dialog
                onClose={handleDialogClose}
                open={open}
                fullScreen
            >
      
                <div className={styles.DateDialog__Content}>    
                    <form 
                        className={styles.DateDialog__Form}
                        onSubmit={handleSubmitForm}
                    >
                    <div className={styles.DateDialog__StartContainer}>
                        <div></div>
                        <div className={styles.DateDialog__TitleContainer}>
                            <div className={styles.DateDialog__Title}>Calendar</div>
                        </div>
                        
                        <div>
                            <IconButton
                                className={styles.CloseSearchButton}
                                aria-label=""
                                size="small"
                                onClick={handleDialogClose}
                            >
                                <CloseIcon
                                    className={styles.CloseSearchButton__Icon}
                                        />
                            </IconButton>
                        </div>
                    </div>
                    <div className={styles.DateDialog__CenterContainer}>
                        <div className={styles.DateDialog__CalendarContainer}>
                            <Calendar                             
                                loading={loading}
                                slots={{
                                    calendarHeader: () => (null),
                                    day: customDay,
                                }}
                        /> 
                        </div>
               
                    </div>
                    <div className={styles.DateDialog__EndContainer}>
                        <div className={styles.DateDialog__ActionsContainer}>
                            <CancelButton 
                                onClick={handleCancelButtonClick}
                            />
                            <ApplyButton
                                onClick={handleApplyButtonClick}
                            />
                        </div>
                       
                    </div>
    </form>
                </div>    
        
        </Dialog>
    )
}